import React from 'react'
import View from '../modules/common/View'

export default () => <View name='product' scrolltop={true} />
